import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToMotorQuote,
    navigateToPersonalDetails,
    navigateToCarDetails,
    navigateToNextOfKin,
    navigateToPayment,
    navigateToDocuments
} from '../../../actions/motorPrivateRW/routing';
import { getActivePageIndex } from '../../../selectors/motorPrivateRW/routing';
import { PAGE_INDICES } from '../../../actions/motorPrivateRW/types';
import { apiTransitionPersonalDetailsForm } from '../../../actions/motorPrivateRW/personalDetails';
import { apiTransitionVehicleDetailsForm } from '../../../actions/motorPrivateRW/carDetails';
import { apiTransitionDocumentsForm } from '../../../actions/motorPrivateRW/Documents';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;
export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS)
        return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToPersonalDetails());
            break;
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToCarDetails());
            break;
        case PAGE_INDICES.CAR_DETAILS:
            store.dispatch(navigateToDocuments());
            break;
        case PAGE_INDICES.DOCUMENTS:
            store.dispatch(navigateToPayment());
            break;
        default:
            store.dispatch(navigateToMotorQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToMotorQuote());
            break;

        case PAGE_INDICES.CAR_DETAILS:
            store.dispatch(apiTransitionPersonalDetailsForm.initial());
            store.dispatch(navigateToPersonalDetails());
            break;
        case PAGE_INDICES.DOCUMENTS:
            store.dispatch(apiTransitionVehicleDetailsForm.initial());
            store.dispatch(navigateToCarDetails());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(apiTransitionDocumentsForm.initial());
            store.dispatch(navigateToDocuments());
            break;
        default:
            store.dispatch(navigateToMotorQuote());
            break;
    }
};
